import React from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import Button from "@material-ui/core/Button";
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        button: {
            margin: theme.spacing(1),
            minWidth: 100,
            padding: 26
        },
    }),
);

const IconWrapper = (props: any) => {
    return (
        <span style={{ display: "flex", justifyContent: "center", alignItems: "center", backgroundColor: "white", borderRadius: 50, marginLeft: 5 }}>
            <NavigateBeforeIcon {...props} style={{ color: "#000", margin: -1 }} />
        </span>
    );
}

const BackButton = ({ setActiveStep, firstStep }: any) => {
    const classes = useStyles();

    const handleBack = async (): Promise<void> => {
        setActiveStep((prevActiveStep: any) => prevActiveStep - 1);
    };
    return (
        <React.Fragment>
            {firstStep ? null :
                <Button className={classes.button} variant="contained" color="secondary" startIcon={<IconWrapper />} onClick={handleBack}>Back
                </Button>}
        </React.Fragment>
    )
}

export default BackButton;